<template>
    <el-dialog :visible.sync="dialogVisible" class="reset-password-container" :title="$t('operations.reset_password.name')"
        size="40%" :close-on-click-modal="false" :before-close="doClose">
        <div class="i-text tip-style">
            <div class="tip-warning">
                <span class="icon-caution"></span>
                <span>{{ $t('create.text.caution') | withColon }}</span>
                {{ $t('game.list.resetPasswordTip', [detailData.name]) }}
            </div>
        </div>
        <el-form ref="ruleForm" label-width="120px" :model="ruleForm" :rules="rules" class="form-style">
            <!--实例名称-->
            <el-form-item :label="$t('listPage.text.exampleName') | withColon">
                <span class="reinstall-tip">{{ detailData.name | maybeEmpty }}</span>
            </el-form-item>
            <!--实例ID-->
            <el-form-item :label="$t('privateNetInstance.instanceID') | withColon">
                <span>{{ detailData.instanceId | maybeEmpty }}</span>
            </el-form-item>
            <!--新密码-->
            <el-form-item :label="$t('passwordReset.newPassword') | withColon" required prop="newPassword"
                :show-message="false" ref="newPassword">
                <section class="password-content">
                    <section class="password-item fl">
                        <el-input class="w300" v-show="!pwdEyes" v-model="ruleForm.newPassword" type="password"
                            auto-complete="off"></el-input>
                        <el-input class="w300" v-show="pwdEyes" v-model="ruleForm.newPassword" type="input"
                            auto-complete="off"></el-input>
                        <span class="eyes" @click="changePwdEyes"
                            :class="{ 'opened-eyes': pwdEyes, 'closed-eyes': !pwdEyes }"></span>
                    </section>
                    <section class="random-password">
                        <span class="random-password-btn" @click="generatePwd">
                            <span class="random-password-icon"></span>
                            <span class="randowm-password-txt">{{ $t('game.create.generatePwd')
                            }}</span>
                        </span>
                        <el-tooltip effect="dark" placement="right" popper-class="charge-mode-tip">
                            <div slot="content">
                                <p class="charge-mode-tip-item">
                                    {{ $t('game.create.randomPasswordTip1') }}
                                </p>
                                <p class="charge-mode-tip-item">
                                    {{ $t('game.create.randomPasswordTip2') }}
                                </p>
                                <p class="charge-mode-tip-item">
                                    {{ $t('game.create.randomPasswordTip3') }}
                                </p>
                            </div>
                            <a><i class="jc-icon-question"></i></a>
                        </el-tooltip>
                    </section>
                </section>
                <p v-if="ruleFormTag.newPassword !== 'valid' && ruleForm.newPassword === ''"
                    class="el-form-item-help-error">
                    {{ $t('create.placeholder.passNull') }}</p>
                <p v-else class="el-form-item-help color-gray"
                    :class="{ 'el-form-item-help-error': ruleFormTag.newPassword === 'error' }">
                    {{ $t('create.help.password') }}
                </p>
            </el-form-item>
            <!--确认密码-->
            <el-form-item :label="$t('create.text.passwordConfirm') | withColon" required prop="newPasswordConfirm">
                <section class="password-item">
                    <el-input class="w300" v-model="ruleForm.newPasswordConfirm" type="password" auto-complete="off"
                        v-show="!confirmPwdEyes"></el-input>
                    <el-input class="w300" v-model="ruleForm.newPasswordConfirm" type="input" auto-complete="off"
                        v-show="confirmPwdEyes"></el-input>
                    <span class="eyes" @click="changeConfirmPwdEyes"
                        :class="{ 'opened-eyes': confirmPwdEyes, 'closed-eyes': !confirmPwdEyes }"></span>
                </section>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="doClose">
                {{ $t('listPage.text.cancelButton') }}
            </el-button>
            <el-button type="primary" @click="doConfirm">
                {{ $t('listPage.text.sureButton') }}
            </el-button>
        </span>
    </el-dialog>
</template>


<script>
// import { generatePassword3 } from 'random-1password';
import { local_generatePassword3 } from '@/common/localGeneratePassword/index'

import { CreateTypeConstant, PasswordRuleConstant } from '@/common/Constants';

export default {
    data() {
        // 新密码验证validator
        const validatePassword = (rule, value, callback) => {
            if (value === '') {
                callback(new Error(this.$t('create.placeholder.passNull')))
            } else {
                // 密码校验规则(8-30个字符，且同时包含三项（大写字母，小写字母，数字或特殊符号()`~!@#$%&*_-+=|{}[]:";'<>,.?/）。)
                const rule = PasswordRuleConstant
                const result = rule.test(value)
                if (!result) {
                    callback(new Error(this.$t('create.placeholder.passNotMeetRequire')));
                }
                callback();
            }
            this.ruleFormTag.newPassword = this.$refs.ruleForm.validateState
        }
        const validatePasswordConfirm = (rule, value, callback) => {
            if (value === '') {
                callback(new Error(this.$t('create.placeholder.confirmPassNull')))
            } else if (value !== this.ruleForm.newPassword) {
                callback(new Error(this.$t('create.placeholder.passNotSame')))
            } else {
                callback();
            }
        }
        return {
            ruleForm: {
                // 新密码
                newPassword: '',
                // 确认密码
                newPasswordConfirm: ''
            },
            ruleFormTag: {
                newPassword: 'valid',
            },
            rules: {
                newPassword: [
                    { validator: validatePassword, trigger: 'blur' }
                ],
                newPasswordConfirm: [
                    {required: true, message: '确认密码不能为空'},
                    { validator: validatePasswordConfirm, trigger: 'blur' }
                ]
            },
            pwdEyes: false,
            confirmPwdEyes: false,
        };
    },
    computed: {
        CreateTypeConstant: () => CreateTypeConstant,
    },
    props: {
        dialogVisible: {
            type: Boolean,
            default: false,
        },
        detailData: {
            type: Object,
        }
    },
    watch: {},
    methods: {
        // 关闭弹框
        doClose() {
            this.resetInitParams();
            this.$emit('update:dialogVisible', false);
        },
        // 点击确认按钮，重置密码
        doConfirm() {
            this.$refs.ruleForm.validate((valid) => {
                if (!valid) {
                    return false
                } else {
                    this.resetPassword();
                }
            })
        },
        resetInitParams() {
            this.$refs.ruleForm.resetFields();
        },
        resetPassword() {
            const param = {
                region: this.detailData.region, // 区域
                createType: CreateTypeConstant.EIP,
                instanceId: this.detailData.instanceId,
                password: this.ruleForm.newPassword,
                clientToken: Normal.getClientToken(),
            };
            Ajax.put('/api/cps/resetPassword', param)
                .then(() => {
                    this.doClose();
                    this.$emit('refreshData')
                })
                .catch(async (err) => {
                    const { response } = err.data;
                    try {
                        const json = await response.json();
                        this.$message.error(json.errmsg);
                    } catch (ex) {
                        console.log(ex);
                    }
                });
        },
        changePwdEyes() {
            this.pwdEyes = !this.pwdEyes;
        },
        changeConfirmPwdEyes() {
            this.confirmPwdEyes = !this.confirmPwdEyes;
        },
        generatePwd() {
            // const pwd = generatePassword3();
            const pwd = local_generatePassword3();
            this.ruleForm.newPassword = pwd;
        }
    },
    mounted() {
    }
};
</script>

<style lang="scss">
.reset-password-container {
    .tip-warning {
        display: flex;
        align-items: center;
        background: #FFF2F0;
        border: 1px solid #FFCCC7;
        border-radius: 2px;
        font-size: 12px;
        color: #333333;
        font-weight: 400;
    }

    .icon-caution {
        margin-right: 5px;
        width: 14px;
        height: 14px;
        display: inline-block;
        background: url('~@/assets/img/game/attention-red.png') center center no-repeat;
        background-size: 100%;
    }

    .form-style {
        margin-top: 20px;
        margin-left: 20px
    }

    .color-gray {
        color: #9e9e9e
    }

    .tip-style {
        width: 90%;
        margin: auto
    }

    .reinstall-tip {
        width: 100%;
        text-align: center;
        word-break: break-word;
    }

    .password-content {
        overflow: hidden;
    }

    .password-item {
        position: relative;
        width: 300px;

        .eyes {
            position: absolute;
            right: 11px;
            top: 50%;
            transform: translateY(-50%);
            width: 16px;
            height: 16px;
            cursor: pointer;
        }

        .opened-eyes {
            background: url('~@/assets/img/game/opened-eyes.png') center center no-repeat;
            background-size: 100%;
        }

        .closed-eyes {
            background: url('~@/assets/img/game/closed-eyes.png') center center no-repeat;
            background-size: 100%;
        }
    }

    .random-password {
        float: left;
        margin-left: 15px;

        .random-password-btn {
            cursor: pointer;
            font-size: 14px;
            color: #666666;
            text-align: center;
            line-height: 14px;
            font-weight: 400;
            vertical-align: middle;
        }

        .random-password-icon {
            display: inline-block;
            width: 16px;
            height: 16px;
            background: url('~@/assets/img/game/refresh-gray.png') center center no-repeat;
            background-size: 100%;
            vertical-align: middle;
        }

        .randowm-password-txt {
            vertical-align: middle;
        }

        &:hover {

            .random-password-icon {
                background-image: url('~@/assets/img/game/refresh-blue.png');
            }

            .random-password-btn {
                color: #2C68FF;
            }
        }
    }

    .jc-icon-question {
        font-size: 14px;
        vertical-align: middle;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/game/ResetPassword.vue